import type { App } from 'vue'
import sjzyWebTracing from '@sjzy/tracing'
import cookie from 'js-cookie'
import proxyConfig from '@/config/proxy.config'

export function setupWebTracing(app: App) {
  if (import.meta.env.VITE_TRACING !== 'true')
    return
  const mode = import.meta.env.MODE
  app.use(sjzyWebTracing, {
    dsn: `${proxyConfig.tracingapi}/tracingapi/trackweb/trackweb`,
    xhr: (xhr) => {
      const token = cookie.get(`${mode}_gtf_token`) || ''
      xhr.setRequestHeader('authorization', token)
    },
    beaconCal: (url) => {
      const token = cookie.get(`${mode}_gtf_token`) || ''
      return `${url}?token=${token?.replace('Bearer ', '')}`
    },
    appCode: 'CRM',
    appName: '客户中心3.0',
    debug: false,
    pv: true,
    error: false,
    event: true,
    performance: false,
    cacheMaxLength: 10,
    cacheWatingTime: 1000,
    recordScreen: false,
    // 忽略请求，不记录
    ignoreRequest: [/tracingapi/, /signalr-hubs/],
    ignoreErrors: [/Error: WebSocket closed/, /micro/, /script 加载错误/],
    beforeSendData(data) {
      data.baseInfo.env = import.meta.env.MODE
      const userStore = useUserStore()
      data.userInfo = userStore.$state
      return data
    },
  })
}
